function toggleProfileExpandMenu(handle) {
  const button = document.querySelector(`button[onclick*="${handle}"]`);
  const submenu = document.querySelector(
    `.mobile-menu-profile-submenu[data-parent="${handle}"]`
  );

  if (!button || !submenu) return;

  const isExpanded = submenu.classList.contains("active");

  if (isExpanded) {
    submenu.classList.remove("active");
    button.classList.remove("active");
  } else {
    const allProfileButtons = document.querySelectorAll(
      ".mobile-menu-profile-menu-link.expand"
    );
    const allProfileSubmenus = document.querySelectorAll(
      ".mobile-menu-profile-submenu"
    );

    allProfileButtons.forEach((btn) => btn.classList.remove("active"));
    allProfileSubmenus.forEach((sub) => sub.classList.remove("active"));

    submenu.classList.add("active");
    button.classList.add("active");
  }
}

window.toggleProfileExpandMenu = toggleProfileExpandMenu;

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("mobile-menu-overlay");
  if (!overlay) return;

  overlay.addEventListener(
    "click",
    function (e) {
      const link = e.target.closest(".mobile-menu-profile-menu a[href*='#']");
      if (!link || !link.href) return;

      try {
        const url = new URL(link.href);
        const current = window.location;
        if (
          url.origin === current.origin &&
          url.pathname === current.pathname &&
          url.hash
        ) {
          if (
            overlay.classList.contains("active") &&
            typeof window.toggleMobileMenu === "function"
          ) {
            window.toggleMobileMenu();
          }
        }
      } catch (_) {}
    },
    true
  );
});
